import { useCurrentPageAccess } from "@/app/router";
import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { DataTable } from "@/shared/components/table";
import { DataTableToolbar } from "@/shared/components/table/DataTableToolbar";
import { Button } from "@/shared/components/ui/button";
import { RotateCw } from "lucide-react";
import { useEffect } from "react";
import { PermissionGroupDialog } from "../components/PermissionGroupDialog";
import { usePermissionGroupColumns } from "../hooks/usePermissionGroupColumns";
import { usePermissionGroups } from "../hooks/usePermissionGroups";

export function UsersPermissionGroupsPage() {
  const vm = usePermissionGroups();
  const { load } = vm;
  const columns = usePermissionGroupColumns();
  const { canWriteCurrentPage } = useCurrentPageAccess();

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <PageHeader
        title="컨트롤 패널 유저 권한 그룹"
        description="컨트롤 패널 유저 권한 그룹을 관리합니다."
      />

      <DataTable
        columns={columns}
        data={vm.rows}
        totalCount={vm.rows.length}
        page={1}
        pageSize={50}
        isLoading={vm.isLoading}
        enableRowSelection
        rowSelectionTrigger="checkbox"
        getRowId={(r) => String(r.id)}
        onRowSelectionChange={(selected) => vm.setSelectedIds(selected.map((r) => r.id))}
        onRowClick={canWriteCurrentPage ? (row) => vm.openEditByRow(row) : undefined}
        toolbar={
          <DataTableToolbar
            filters={
              <div className="text-sm text-muted-foreground">
                {vm.summary.selected > 0 && (
                  <>
                    {" · "}선택{" "}
                    <span className="font-medium text-foreground">{vm.summary.selected}</span>개
                  </>
                )}
              </div>
            }
            actions={
              <>
                <Button variant="outline" onClick={vm.load}>
                  <RotateCw className="mr-2 h-4 w-4" />
                  새로고침
                </Button>
                <Button onClick={vm.openAdd} disabled={!canWriteCurrentPage}>
                  추가
                </Button>
                <Button
                  variant="destructive"
                  onClick={vm.deleteSelected}
                  disabled={!canWriteCurrentPage}
                >
                  삭제
                </Button>
              </>
            }
          />
        }
      />

      <PermissionGroupDialog
        open={vm.modalOpen}
        mode={vm.modalMode}
        groupName={vm.groupName}
        onGroupNameChange={vm.setGroupName}
        grants={vm.grants}
        onSetGrant={vm.setGrantForPage}
        errMsg={vm.errMsg}
        onCancel={vm.closeModal}
        onSubmit={vm.submit}
      />
    </div>
  );
}
